const API_URL = `${process.env.REACT_APP_URL_API}${process.env.REACT_APP_PATH_AUTH}`;

export const login = async (correo, password) => {
    try {
        const url = `${API_URL}/login`
        //console.log(url);
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ correo, password }),
        });
        if (!response.ok) {
            throw new Error('Login fallido');
        }
        const data = await response.json();
        return data;
    } catch (error) {
        throw error;
    }
};


export const registerUser = async (correo, password, nombre, apellido1, apellido2, telefono, modulos, rol) => {
    try {
        const url = `${API_URL}/register`
        //console.log(url);
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ correo, password, nombre, apellido1, apellido2, telefono, modulos, rol }),
        });

        if (!response.ok) {
            throw new Error('Registro fallido');
        }

        const data = await response.json();

        return data;
    } catch (error) {
        console.error('Error al registrar usuario:', error); // Loguear el error completo
        throw error;
    }
};

//funcion que verifica si ya existe un usuario con el correo
export const verifyUser = async (correo) => {
    try {
        const url = `${API_URL}/verificar`
        //console.log(url);
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body:JSON.stringify({ correo })
        });
        if (!response.ok) {
            throw new Error('Error al verificar usuario');
        }
        console.log(response);
        const data = await response.json();
        
        return data.exists;
    } catch (error) {
        throw error;
    }
};
